<script>
import { mapGetters } from 'vuex'
import { MixPanel } from '@/mixin/mixpanel'

export default {
  mixins: [MixPanel],
  data() {
    return {
      phaseOneShow: false,
      books: [],
    }
  },
  computed: {
    ...mapGetters({
      hasAccess: 'identity/hasAccess',
      hasAccessAll: 'identity/hasAccessAll',
      isNewSubmodule: 'identity/isNewSubmodule',
      getFeatureFlagData: 'identity/getFeatureFlagData',
    }),
  },
  watch: {
    '$i18n.locale': function () {
      const getLanguage = localStorage.getItem('language') === 'en' ? 'en' : 'id'
      if (getLanguage === 'en') {
        const newBooks = this.books.map((item) => {
          const title = item.title.toLowerCase().replace(/\s/g, '')
          return {
            ...item,
            title: this.$t('help.books.' + title),
          }
        })
        this.books = newBooks
      } else {
        this.books = []
        this.grantAccess()
      }
    },
  },
  mounted() {
    setTimeout(() => {
      this.grantAccess()
      this.setSubmodule()
    }, 800)
    this.mixpanelBook()
  },
  methods: {
    grantAccess() {
      const books = JSON.parse(this.getFeatureFlagData('vsms2_userguide').value)
      const mapIdWithScopeAccess = {
        1: 'help_login:read',
        2: 'help_dasbor:read',
        3: 'help_default:read',
        4: 'help_pengiriman:read',
        5: 'help_penugasan:read',
        6: 'help_pelacakanvideo:read',
        7: 'help_pelacakan_rute:read',
        8: 'help_penilaianpengemudi:read',
        9: 'help_notifikasi:read',
        10: 'help_lisensi:read',
        11: 'help_laporan:read',
        12: 'help_pemeliharaan:read',
        13: 'help_masterdata:read',
        14: 'help_pelacakansementara:read',
        15: 'help_pengaturan:read',
        16: 'help_bantuandankontakkami:read',
      }

      for (const iterator of books) {
        if (this.hasAccess(mapIdWithScopeAccess[iterator.id])) {
          this.books.push(iterator)
        }
      }
    },
    setSubmodule() {
      const mapIdWithSubmodule = {
        1: 'f1a-help-login',
        2: 'f2a-help-dasbor',
        3: 'f3a-help-liveview',
        4: 'tms-main',
        5: 'tms-main',
        6: 'f7a-help-pelacakanvideo',
        7: 'd7a-default-md-route',
        8: 'f8a-help-penilaianpengemudi',
        9: 'f4a-help-notifikasi',
        10: 'f9a-help-lisensi',
        11: 'f10a-help-laporan',
        12: 'f17-help-pemeliharaan',
        13: 'f6a-help-masterdata',
        14: 'f11a-help-pelacakansementara',
        15: 'f5a-help-pengaturan',
        16: 'f12a-help-bantuandankontakkami',
      }

      for (const iterator of this.books) {
        const idx = this.books.findIndex((e) => e.id === iterator.id)
        const isNewSubmodule = this.isNewSubmodule(mapIdWithSubmodule[iterator.id])
        this.books[idx] = { ...this.books[idx], isNewSubmodule }
      }
    },
    mixpanelBook() {
      this.track('View Buku Petunjuk Pengguna')
    },
  },
}
</script>

<template>
  <b-tab active class="border-0" @click="mixpanelBook">
    <template v-slot:title>
      <span class="d-sm-inline-block">{{ $t('help.guideBook') }}</span>
    </template>

    <div class="mc-help">
      <h4 class="pb-3 mb-0 border-1 border-bottom mc-help__title">
        <strong>{{ $t('help.userGuide') }}</strong>
      </h4>

      <b-tabs content-class="p-3 text-muted" class="mc-help-menu clearfix">
        <b-tab v-for="book in books" :key="book.id" :active="book.id == 1">
          <template v-slot:title>
            <span class="mc-help__sidebar-link">{{ book.title }} </span>
            <span
              v-if="book.isNewSubmodule"
              class="badge float-end rounded-pill text-end mc-badge__submodule__help"
              >{{ $t('global.new') }}
            </span>
          </template>
          <div class="mc-help__content-item-download">
            <figure>
              <img src="@/assets/images/vsms.svg" alt />
            </figure>
            <h4>{{ $t('help.guide') }} {{ book.title }} VSMS 2.0</h4>
            <p>{{ $t('help.guideFor') }} {{ book.title }} VSMS 2.0</p>
            <a :href="book.url" target="_blank"></a>
          </div>
        </b-tab>
      </b-tabs>
    </div>
  </b-tab>
</template>
